import { Rule } from '@webkit/validation/value';

export const regex = (pattern: RegExp, error?: string) =>
    ({
        id: 'regex',
        validator: value => {
            if (!value) return true;
            return pattern.test(value);
        },
        error: () => error || 'Invalid format',
    } as Rule<string>);
